import clsx from "clsx";
import Button from "../../button";
import ControlGroup from "../../controlgroup";
import Slider from "../../slider";
import { SliderControlProps } from "../types";

export default function SliderControl(
  props: Readonly<Omit<SliderControlProps, "type">>,
) {
  const {
    value,
    size = "md",
    min,
    max,
    step,
    hideMinMax,
    getInputRef,
    onChange,
    valueFormater,
    ...rest
  } = props;
  return (
    <ControlGroup size={size}>
      {!hideMinMax && (
        <ControlGroup.Item>
          <ControlGroup.Button
            variant="secondary"
            onClick={() => onChange?.(min)}
          >
            {min}
          </ControlGroup.Button>
        </ControlGroup.Item>
      )}
      <ControlGroup.Item grow>
        <Slider
          {...rest}
          ref={getInputRef}
          value={value}
          size={size}
          min={min}
          max={max}
          step={step}
          onChange={onChange}
          className={clsx("h-full rounded-none border-0 bg-white", {
            "h-[46px]": size === "lg",
            "h-[38px]": size === "md",
            "h-[30px]": size === "sm",
          })}
          thumbClassName="-translate-y-[1px]"
          trackClassName={clsx({
            "h-10": size === "lg",
            "h-9": size === "md",
            "h-7": size === "sm",
          })}
          renderThumb={(thumbProps, state) => (
            <div {...thumbProps}>
              <Button
                size="sm"
                className={clsx("rounded-none px-1 border-gunmetal-200", {
                  "py-1.5 text-sm": size === "sm",
                  "py-2 text-base": size === "md",
                  "py-2.5 text-xl": size === "lg",
                })}
              >
                <span
                  style={{
                    minWidth: max.toString().split("").length * 9 + "px",
                    display: "inline-block",
                  }}
                >
                  {valueFormater?.(state.valueNow) ?? state.valueNow}
                </span>
              </Button>
            </div>
          )}
        />
      </ControlGroup.Item>
      {!hideMinMax && (
        <ControlGroup.Item>
          <ControlGroup.Button
            variant="secondary"
            onClick={() => onChange?.(max)}
          >
            {max}
          </ControlGroup.Button>
        </ControlGroup.Item>
      )}
    </ControlGroup>
  );
}
